<template>
  <div v-show="staffList.length" class="comp-main">
    <div class="group-list">
      <div class="group-item">
        <div class="group-top">员工</div>
        <div class="group-center">
          <el-input
            size="mini"
            prefix-icon="el-icon-search"
            :placeholder="`筛选员工`"
            clearable
            v-model="keyword"
            @input="filterStaff($event)"
          />
          <div class="group-cont">
            <c-list-empty v-if="!staffList.length" />
            <div
              v-for="(item, index) in staffList"
              :key="index"
              :class="{ 'staff-item': true, active: selfData.id === item.id }"
              @click="staffChoose(item)"
              v-show="item.isShow"
            >
              <span class="staff-name">{{ item.key }}</span>
              <div>
                <span v-if="item.has_children" class="iconfont icon-arrow-right c-gray-light" />
                <span v-else class="iconfont icon-right" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    departmentId: {
      type: [String, Number],
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isFirst: true,
      keyword: '',
      staffList: [],
      selfData: {}
    }
  },
  watch: {
    departmentId(id) {
      this.keyword = ''
      if (id) {
        this.getStaffListList(id)
      } else {
        this.staffChoose({})
        this.staffList = []
      }
    },
    data: {
      handler(val) {
        if (JSON.stringify(this.selfData) !== JSON.stringify(val)) {
          this.selfData = this.$util.deepCopy(val)
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取员工列表数据
    getStaffListList(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/midu/list',
        params: {
          id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.staffList = res.data.list.map((item) => {
            let obj = {
              id: item.id,
              key: item.cai_zhi,
              val: item.val,
              isShow: true
            }
            return obj
          })
          if (this.isFirst && this.staffList.length) {
            if (this.data && this.data.key) return
            this.selfData = this.$util.deepCopy(this.staffList[0])
            this.staffChoose(this.selfData, true)
          } else {
            this.staffChoose({})
          }
          this.isFirst = false
        }
      })
    },
    // 员工筛选
    filterStaff(keyword) {
      this.staffList.forEach((item) => {
        item.isShow = item.key.includes(keyword)
      })
    },
    // 员工选择
    staffChoose(val, isFirst = false) {
      this.$emit('update:data', this.$util.deepCopy(val))
      // 是否隐藏部门 = 不是第一次加载 && 选中末级部门 && (员工列表为空 || (员工列表不为空 && 选中员工))
      let isHideCategory =
        !isFirst &&
        this.departmentId &&
        (!this.staffList.length || (this.staffList.length && JSON.stringify(val) !== '{}'))
      if (isHideCategory) {
        this.$emit('hide')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.comp-main {
  position: relative;
  min-height: 28px;
  .group-list {
    display: flex;
    .group-item {
      display: flex;
      flex-direction: column;
      width: 200px;
      line-height: 26px;
      background: @colorWhite;
      border: 1px solid #e4e7ed;
      & ~ .group-item {
        border-left: none;
      }
      &:first-child {
        border-radius: 2px 0 0 2px;
      }
      &:last-child {
        border-radius: 0 2px 2px 0;
      }
      .group-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 5px;
        background: #f8f8f9;
      }
      .group-center {
        height: 252px;
        border-top: 1px solid #e4e7ed;
        .group-cont {
          height: 224px;
          overflow-y: auto;
          .scroll-bar();
        }
        /deep/ .el-input {
          height: 28px;
          .el-input__inner {
            height: 28px;
            line-height: 26px;
            border: none;
            border-radius: 0;
            border-top: 1px solid #fff;
            border-bottom: 1px solid #e4e7ed;
          }
        }
        .staff-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 28px;
          padding: 0 5px;
          cursor: pointer;
          .icon-right,
          .icon-edit,
          .icon-delete {
            display: none;
          }
          &:hover,
          &.active {
            background: @colorBlue10;
          }
          &.active {
            .staff-name,
            .icon-arrow-right,
            .icon-right {
              color: @colorBlue;
            }
            .icon-right,
            .icon-edit,
            .icon-delete {
              display: block;
            }
            .icon-edit:hover,
            .icon-delete:hover {
              color: @colorBlue;
            }
          }
        }
      }
    }
  }
  .iconfont {
    cursor: pointer;
    & ~ .iconfont {
      margin-left: 5px;
    }
  }
}
</style>
